/* istanbul ignore file */
export enum TagType {
  TAG = 'tag',
  CATEGORY = 'category',
}
